var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5079_14149",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4499 16.45V1.55005H1.55V16.45H16.4499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5079_14149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25728 2.00011C4.36978 2.00011 2 4.17483 2 6.82171C2 8.14085 2.58187 9.3351 3.52261 10.2017L2 11.6143H7.25728C10.1448 11.6143 12.4855 9.46853 12.4855 6.82171C12.4855 4.17483 10.1448 2.00011 7.25728 2.00011Z",
    stroke: "#4D555E",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4823 6.65758C14.5145 7.31471 15.9999 9.09066 15.9999 11.1784C15.9999 12.4975 15.418 13.7208 14.4773 14.5875L15.9999 16H10.7426C8.01531 16 5.77577 14.0567 5.53564 11.6141",
    stroke: "#4D555E",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64307 4.64355H9.8713",
    stroke: "#4D555E",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64307 6.38574H9.8713",
    stroke: "#4D555E",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64307 8.12891H9.8713",
    stroke: "#4D555E",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.7eeb77e8e969390ce5f4467d6153bbb1.svg";
export { ForwardRef as ReactComponent };